import { useDispatch, useSelector } from "react-redux";

import BaseNavbar from "./shared/BaseNavbar";
import BrandLogo from "./shared/BrandLogo";
import MobileMenuTrigger from "./shared/MobileMenuTrigger";
import NavbarLink from "./shared/NavbarLink";
import ThemeSelector from "./shared/ThemeSelector";
import ClinicSelectorDropdown from "./shared/ClinicSelectorDropdown";
import Dropdown from "../auxiliar/ui/Dropdown";
import UnderlyingSpan from "./shared/UnderlyingSpan";
import { logout } from "../../../actions/auth";
import { handleSubmitWithDispatch } from "../../../auxiliar/auxFunctions";
import { handleBlurOnClick } from "./shared/navbarUtils";

const NavbarLoggedIn = () => {
    const dispatch = useDispatch();
    const userType = useSelector((state) => state.auth.user_type);
    const clinicID = useSelector((state) => state.activeClinic.id);

    // Build dropdown items based on user type
    const getLinks = () => {
        const baseItems = [
            { to: "/agenda", label: "Agenda", position: 0 },
            { to: "/patient", label: "Pacientes", position: 1 },
            { to: "/task", label: "Tareas", position: 3 },
        ];

        const managerItems = [
            { to: "/cash-register", label: "Facturación", position: 2 },
            { to: "/services", label: "Servicios", position: 4 },
            { to: "/clinic", label: "Clínicas", position: 5 },
            { to: "/profile", label: "Perfil", position: 6 },
        ];

        const clinicItems = [
            { to: "/services", label: "Servicios", position: 4 },
            { to: `/clinic/${clinicID}`, label: "Clínica", position: 5 },
        ];

        if (userType === "manager") {
            return [...baseItems, ...managerItems];
        } else if (userType === "clinic") {
            return [...baseItems, ...clinicItems];
        }
        return baseItems;
    };

    const startContent = (
        <>
            <Dropdown trigger={<MobileMenuTrigger />} items={getLinks()} className="xl:hidden" />
            <BrandLogo to="/agenda" size="desktop" />
            <div className="hidden sm:flex ml-4">
                <ClinicSelectorDropdown />
            </div>
        </>
    );

    const centerContent = (
        <>
            <div className="px-1 hidden xl:flex gap-1 items-center">
                {getLinks()
                    .sort((a, b) => a.position - b.position)
                    .map((link) => (
                        <NavbarLink key={link.to} to={link.to}>
                            {link.label}
                        </NavbarLink>
                    ))}
            </div>
            <BrandLogo to="/agenda" size="mobile" />
        </>
    );

    const endContent = (
        <div className="flex items-center gap-4">
            <ThemeSelector />
            <button
                className="btn btn-ghost hover:bg-gradient-to-r hover:from-error/10 hover:to-error/5 hover:text-error active:bg-gradient-to-r active:from-error/15 active:to-error/8 active:text-error transition-all duration-300 font-medium focus:outline-none focus:ring-2 focus:ring-error/30 focus:ring-offset-2 focus:ring-offset-base-100 active:scale-95 group"
                onClick={(e) => {
                    handleBlurOnClick(e);
                    handleSubmitWithDispatch(dispatch, logout)(e);
                }}
            >
                <span className="relative">
                    Salir
                    <UnderlyingSpan className="bg-gradient-to-r from-error to-error/60" />
                </span>
            </button>
        </div>
    );

    return (
        <BaseNavbar
            startContent={startContent}
            centerContent={centerContent}
            endContent={endContent}
        />
    );
};

export default NavbarLoggedIn;
